import React from 'react';
import Loading from 'src/Components/Loading';
import { useReports, useReportsByTags } from 'src/hooks/queries/transactions';
import { toPersianNumbers } from 'src/utils/numbers';
import toPrice from 'src/utils/toPrice';
import ReportsWrapper from './styles';

const Reports: React.FC = () => {
	const { data: reportData, isLoading } = useReports();
	const { data: reportsByTagsData, isLoading: reportsByTagsLoading } =
		useReportsByTags();

	return (
		<ReportsWrapper>
			{(isLoading || reportsByTagsLoading) && <Loading center />}
			{!isLoading && reportData && (
				<>
					<div className='report-box'>
						<span className='title'>
							جمع هزینه‌های این ماه تا الان
						</span>
						<span className='price'>
							{toPersianNumbers(
								toPrice(reportData?.totalMonthTransactionPrice),
							)}{' '}
							<span className='currency'>تومان</span>
						</span>
					</div>
					<div className='report-box'>
						<span className='title'>
							جمع هزینه‌های امروز تا الان
						</span>
						<span className='price'>
							{toPersianNumbers(
								toPrice(reportData?.totalDayTransactionPrice),
							)}{' '}
							<span className='currency'>تومان</span>
						</span>
					</div>
				</>
			)}
			{!reportsByTagsLoading && reportsByTagsData && (
				<ul className='report-box report-by-tags'>
					{Object.entries(reportsByTagsData?.reports).map(
						(reportTagItem) => (
							<li
								className='report-item'
								key={String(reportTagItem[1])}
							>
								<span className='key'>{reportTagItem[0]}</span>
								<span className='value'>
									<span className='price'>
										{toPersianNumbers(
											toPrice(reportTagItem[1]),
										)}{' '}
										<span className='currency'>تومان</span>
									</span>
								</span>
							</li>
						),
					)}
				</ul>
			)}
		</ReportsWrapper>
	);
};

export default Reports;
